module.exports = __webpack_public_path__ + "assets/images/50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50.png
// module id = 1299
// module chunks = 1